<template>
    <div class="badge-2-wrapper" :style="((widget_data.widget.settings.badge_display == 'Embed' ? 'margin: auto;': ''))">
        <v-card
            elevation="2"
            class="reviews-badge"
            @click="$parent.showDialog()"
            rounded
            :style="'border-radius: 3px !important; padding-top: 0px; background-color: ' + ((widget_data.widget.settings.background_type == 'Transparent') ? 'transparent' : widget_data.widget.settings.background_color) + '; color: ' + widget_data.widget.settings.text_color + ';'"
        >
            <div class="top-border" :style="'background: ' + widget_data.widget.settings.badge2_top_color"></div>

            <div class="clearfix">
                <div class="float-left" style="width: 60px; padding-top: 15px; padding-left: 10px;">
                    <div v-if="widget_data.widget.settings.platforms.length == 1">
                        <img v-for="(item, index) in widget_data.widget.settings.listings" :key="index" v-show="listingEnabled(item.id)"
                            :src="getIconUrl(item.url)"
                            class="listing-img"
                        >
                    </div>
                    <div v-else class="-mt-2">
                        <i class="mdi mdi-share-variant-outline" :style="'font-size: 50px; color: ' + widget_data.widget.settings.star_color"></i>
                    </div>
                </div>
            

                <div class="float-left" style="width: calc(100% - 60px); padding-left: 10px;">
                    <div class="reviews-title reviews-read-link text-sm">
                        {{ ((widget_data.widget.settings.badge_2_title) ? widget_data.widget.settings.badge_2_title.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating) : "Our Rating") }}
                    </div>

                    <div :style="'display: inline-block; font-size: 23px; color: ' + widget_data.widget.settings.star_color">
                        {{ widget_data.average_rating }}
                    </div>

                    <div style="display: inline-block; vertical-align: super;">
                        <v-rating
                            class="reviews-rating"
                            :value="parseFloat(widget_data.average_rating)"
                            :color="widget_data.widget.settings.star_color"
                            dense
                            half-increments
                            readonly
                            size="24"
                        ></v-rating>
                    </div>

                    <div class="reviews-title reviews-read-link text-xs">
                        {{ ((widget_data.widget.settings.badge_2_subtitle) ? widget_data.widget.settings.badge_2_subtitle.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating) : "Based on " + widget_data.total_reviews + " reviews") }}
                    </div>
                </div>
            </div>

            <div class="clearfix"></div>
        </v-card>

        <div v-if="widget_data.widget.subscription.stripe_id == 'starter'" class="reviews-footer" :style="'color: ' + widget_data.widget.settings.footer_text_color + '; text-align: center;'">
            Powered by <a href="https://reviewgrower.com/" target="review-grower-external" :style="'color: ' + widget_data.widget.settings.footer_link_color + ';'">Review Grower</a>
        </div>
    </div>
</template>

<script>
import Header from '@/views/panel/Business/Widgets/Render/Header.vue';
import Review from '@/views/panel/Business/Widgets/Render/Review.vue';
import urlParser from 'url-parse'

export default {
    props: ["widget_data", "fw"],

    components: {
        Header,
        Review
    },
    
    methods: {
        getHostname(url) {
            return urlParser(url).hostname.replace("www.", "")
        },
        getPathname(url) {
            return urlParser(url).pathname
        },
        getIconUrl(url) {
            return require('@/assets/images/review-services/www.' + this.getHostname(url) + ".png");
        },
        listingEnabled(id) {
            console.log('id', id);
            console.log('this.widget_data.widget.settings.platforms', this.widget_data.widget.settings.platforms);
            for (var i in this.widget_data.widget.settings.platforms) {
                if (this.widget_data.widget.settings.platforms[i] == id)
                    return true;
            }

            return false;
        }
    }
}
</script>

<style type="text/css" scoped>
    .badge-2-wrapper {
        width: 235px;
        padding-bottom: 10px;
    }

    .top-border {
        width: calc(100% + 3px);
        height: 8px;
        margin-bottom: 5px;
        margin-left: -1px;
    }

    .listing-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: inline-block;
    }
</style>